import script from "./UserAssignToServiceProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAssignToServiceProvider.vue?vue&type=script&setup=true&lang=ts"

import "./UserAssignToServiceProvider.vue?vue&type=style&index=0&id=243c890b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243c890b"]])

export default __exports__